import React from 'react';
import type { FC } from 'react';
import { match, constant } from 'variant';
import { Alert, useExit } from '@wix/cli-ui-kit';
import { SiteSelector } from '@wix/cli-site-selector';
import { useBiLogger } from '@wix/cli-telemetry-react';
import { useProjectModel } from '../model.js';
import type { SiteState } from './site-state.js';

interface Props {
  state: SiteState<'NotConfigured'>;
  onSubmit: (siteId: string) => void;
}

export const ResolveSite: FC<Props> = ({ state, onSubmit }) => {
  const exit = useExit();
  const { model } = useProjectModel();
  const biLogger = useBiLogger();

  return (
    <>
      {match(state, {
        NotConfigured: constant(
          <Alert type="insight">
            You don't have a Development Site currently configured
          </Alert>
        ),
      })}
      <SiteSelector
        appId={model.config.appId}
        biLogger={biLogger}
        onSubmit={(site) => onSubmit(site.id)}
        onError={exit}
      />
    </>
  );
};
